import GroupedWidget from "./GroupedWidget";
import ListWidget from "./ListWidget";
import NumericWidget from "./NumericWidget";
import PieChartWidget from "./PieChartWidget";
import WidgetBase from "./WidgetBase";

type WidgetTypes = ListWidget | PieChartWidget | GroupedWidget | NumericWidget;

export type WidgetView = {
    name: string;
    widgetIds: string[];
};

export type UserWidgetData = {
    widgets: WidgetBase[];
    views: WidgetView[];
};

export const DEFAULT_DASHBOARD_VIEW_KEY = "default_view";

export default WidgetTypes;
